import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlProcessorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlProcessorComponent, _super);
    function PetlProcessorComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this.createProject = true;
        _this.newProjectLabel = 'New Project';
        _this.newScenarioLabel = 'New Scenario';
        _this.projectList = [];
        _this.simpleScenarioPrefix = 'Scenario';
        _this.specificHelpShown = null;
        _this.unusedFieldsMarginLeft = 0;
        return _this;
    }
    Object.defineProperty(PetlProcessorComponent.prototype, "project", {
        get: function () {
            return this.service.project;
        },
        set: function (value) {
            this.service.project = value;
        },
        enumerable: true,
        configurable: true
    });
    PetlProcessorComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.petlService.project) {
                    this.startNewFile();
                }
                this.fileUploadedSubscription = this.petlService.fileUploaded.subscribe(function () {
                    _this.startNewFile();
                });
                return [2 /*return*/];
            });
        });
    };
    PetlProcessorComponent.prototype.ngOnDestroy = function () {
        this.fileUploadedSubscription.unsubscribe();
    };
    Object.defineProperty(PetlProcessorComponent.prototype, "enableValidateButton", {
        get: function () {
            return this.projectDescriptionIsValid && this.petlColumnMapping.geometryIsValid() && (this.scenarioIsValid() || !this.advanced);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlProcessorComponent.prototype, "projectDescriptionIsValid", {
        get: function () {
            return this.project && this.project.description !== this.newProjectLabel && this.project.description && (!this.createProject || !this.projectDescriptionExistsInAnotherProject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlProcessorComponent.prototype, "willOverwriteScenario", {
        get: function () {
            var willOverwrite = this.project !== null && this.enableValidateButton && this.project.scenarios && this.project.scenarios.length > 0;
            willOverwrite = willOverwrite && (!this.advanced && !this.append) || (this.scenario && this.scenario.id);
            return willOverwrite;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlProcessorComponent.prototype, "projectDescriptionExistsInAnotherProject", {
        get: function () {
            var _this = this;
            if (!this.projectList || !this.project) {
                return false;
            }
            var arr = this.projectList.filter(function (project) {
                return (project.originalDescription === _this.project.description && project.id !== _this.project.id);
            });
            return arr.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    PetlProcessorComponent.prototype.startNewFile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initializeVariables();
                        this.initializeScenario();
                        this.createNewProject();
                        this.resetNewScenario();
                        return [4 /*yield*/, this.refreshProjectList()];
                    case 1:
                        _a.sent();
                        this.project = this.newProject;
                        this.setProjectListFromServiceProjectList();
                        this.createProject = !this.setExistingProjectIfIdOrFilenameMatches();
                        return [4 /*yield*/, this.projectChanged()];
                    case 2:
                        _a.sent();
                        // this.cdr.detectChanges();
                        this.petlService.fileDropped = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlProcessorComponent.prototype.projectChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fullProject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetNewScenario();
                        this.petlService.resetAliases();
                        if (!(this.project && this.project.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.petlService.getProject(this.project.id)];
                    case 1:
                        fullProject = _a.sent();
                        if (fullProject) {
                            this.project.columnAliases = fullProject.columnAliases;
                            this.petlService.updateColumnAliasesFromProject();
                        }
                        this.petlColumnMapping.refresh();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PetlProcessorComponent.prototype.processMapping = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.scenario) {
                            this.initializeScenario();
                        }
                        this.fileName = this.petlService.fileName;
                        this.fileExtension = this.petlService.getFileExtension();
                        this.delimiter = ',';
                        // Sets the project id from the service project id. TODO Reconsider the placement of this code.
                        if (this.petlService.project.id && !this.project.id) {
                            this.project.id = this.petlService.project.id;
                        }
                        this.refreshColumnMapping();
                        return [4 /*yield*/, this.petlService.sendProcessForm(this)];
                    case 1:
                        _a.sent();
                        this.project = this.petlService.project;
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlProcessorComponent.prototype.validate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.createProject) {
                            this.project = this.newProject;
                        }
                        this.updateProjectAliasesBasedOnMapping();
                        _a = this;
                        return [4 /*yield*/, this.petlService.addOrUpdateProject()];
                    case 1:
                        _a.project = _b.sent();
                        this.createProject = false;
                        this.lastCreatedProject = this.project;
                        this.processMapping();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlProcessorComponent.prototype.initializeVariables = function () {
        this.newProjectLabel = 'New Project';
        this.newScenarioLabel = 'New Scenario';
        this.simpleScenarioPrefix = 'Scenario';
        this.advanced = false;
        this.append = false;
        this.createProject = true;
        this.project = null;
        this.petlColumnMapping.initialize();
    };
    PetlProcessorComponent.prototype.createNewProject = function () {
        var e_1, _a;
        this.newProject = {};
        this.newProject.id = null;
        this.newProject.selectLabel = this.newProjectLabel;
        var fileExtensions = ['csv', 'xlsx', 'xls'];
        var newProjectDescription = '';
        if (this.petlService.fileName) {
            newProjectDescription = this.petlService.fileName;
        }
        try {
            for (var fileExtensions_1 = tslib_1.__values(fileExtensions), fileExtensions_1_1 = fileExtensions_1.next(); !fileExtensions_1_1.done; fileExtensions_1_1 = fileExtensions_1.next()) {
                var fileExension = fileExtensions_1_1.value;
                var exension = '.' + fileExension;
                newProjectDescription = newProjectDescription.replace(exension, '').replace(exension.toUpperCase(), '');
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (fileExtensions_1_1 && !fileExtensions_1_1.done && (_a = fileExtensions_1.return)) _a.call(fileExtensions_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.newProject.description = newProjectDescription;
        var lifeSpan = 60;
        this.newProject.lifeSpanDays = lifeSpan;
        this.newProject.columnAliases = [];
    };
    PetlProcessorComponent.prototype.redefineStartingRowNumber = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.petlService.redefineStartingRowNumber()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlProcessorComponent.prototype.initializeScenario = function () {
        this.newScenario = {};
        this.newScenario.id = null;
        this.newScenario.selectLabel = this.newScenarioLabel;
        this.newScenario.description = 'Scenario 1';
        this.scenario = this.newScenario;
    };
    PetlProcessorComponent.prototype.resetNewScenario = function () {
        if (!this.newScenario) {
            return;
        }
        this.scenario = this.newScenario;
        if (!this.advanced) {
            if (this.append) {
                this.newScenario.description = this.project.nextSimpleScenarioName;
            }
            else {
                this.newScenario.description = this.simpleScenarioPrefix + ' 1';
            }
        }
        else {
            this.newScenario.description = '';
            if (this.project.scenarios.length > 0) {
                this.scenario = this.project.scenarios[0];
            }
            else if (this.project.selectScenarios.length > 0) {
                this.scenario = this.project.selectScenarios[0];
            }
        }
    };
    PetlProcessorComponent.prototype.refreshProjectList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.petlService.getProjectList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlProcessorComponent.prototype.setProjectListFromServiceProjectList = function () {
        var e_2, _a;
        if (!this.projectList) {
            this.projectList = [];
        }
        this.projectList.length = 0;
        try {
            for (var _b = tslib_1.__values(this.petlService.projectList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var project = _c.value;
                project.originalDescription = project.description;
                project.selectLabel = project.id.toString() + " - " + project.description;
                this.populateProjectScenarioList(project);
                this.setNewSimpleScenarioNameForProject(project);
                this.projectList.push(project);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    PetlProcessorComponent.prototype.setExistingProjectIfIdOrFilenameMatches = function () {
        var e_3, _a;
        var found = false;
        try {
            for (var _b = tslib_1.__values(this.projectList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var project = _c.value;
                if (this.petlService.project && project.id === this.petlService.project.id) {
                    this.project = project;
                    return true;
                }
                else if (this.newProject && project.description === this.newProject.description) {
                    this.project = project;
                    found = true;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return found;
    };
    PetlProcessorComponent.prototype.scenarioNameExists = function (testProject, testDescription) {
        var _this = this;
        if (testProject === void 0) { testProject = null; }
        if (testDescription === void 0) { testDescription = null; }
        if (!testProject) {
            testProject = this.project;
        }
        if (!testDescription) {
            testDescription = this.scenario.description;
        }
        if (!testProject || !testProject.scenarios) {
            return false;
        }
        var arr = testProject.scenarios.filter(function (scenario) {
            return (scenario.description === testDescription && (!_this.scenario || scenario.id !== _this.scenario.id));
        });
        return arr.length > 0;
    };
    PetlProcessorComponent.prototype.populateProjectScenarioList = function (project) {
        var e_4, _a;
        project.selectScenarios = [];
        project.selectScenarios.push(this.newScenario);
        if (project.scenarios) {
            try {
                for (var _b = tslib_1.__values(project.scenarios), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var scenario = _c.value;
                    scenario.selectLabel = scenario.description;
                    project.selectScenarios.push(scenario);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        else {
            project.scenarios = [];
        }
    };
    PetlProcessorComponent.prototype.setNewSimpleScenarioNameForProject = function (project) {
        var i = 1;
        var limit = 100;
        while (!project.nextSimpleScenarioName && i < limit) {
            var possibleUnqiueName = this.simpleScenarioPrefix.toString() + " " + i.toString();
            if (!this.scenarioNameExists(project, possibleUnqiueName)) {
                project.nextSimpleScenarioName = possibleUnqiueName;
            }
            i++;
        }
    };
    PetlProcessorComponent.prototype.startOver = function () {
        this.initializeScenario();
        this.petlService.startOver();
    };
    PetlProcessorComponent.prototype.scenarioIsValid = function () {
        return this.project && this.scenario && this.scenario.description && (this.scenario.id !== null || this.scenarioNameIsValid());
    };
    PetlProcessorComponent.prototype.scenarioNameIsValid = function () {
        return this.scenario.description !== this.newScenarioLabel && !this.scenarioNameExists();
    };
    PetlProcessorComponent.prototype.refreshColumnMapping = function () {
        this.petlColumnMapping.refreshColumnMapping();
    };
    PetlProcessorComponent.prototype.toggleSpecificHelp = function (specificHelp) {
        if (this.specificHelpShown === specificHelp) {
            this.specificHelpShown = null;
        }
        else {
            this.specificHelpShown = specificHelp;
        }
    };
    PetlProcessorComponent.prototype.closeHelp = function () {
        this.specificHelp = null;
    };
    PetlProcessorComponent.prototype.toggleNewProject = function () {
        this.createProject = !this.createProject;
        if (this.createProject) {
            this.project = this.newProject;
        }
    };
    PetlProcessorComponent.prototype.updateProjectAliasesBasedOnMapping = function () {
        var _this = this;
        this.project.columnAliases = [];
        this.petlService.columnData.forEach(function (val) {
            if (val.databaseField && val.databaseField.aliasName) {
                _this.project.columnAliases.push({ columnName: val.databaseField.databaseName, aliasName: val.databaseField.aliasName });
            }
        });
    };
    PetlProcessorComponent.prototype.checkLifeSpan = function () {
        if (this.project.lifeSpanDays < 0) {
            this.project.lifeSpanDays = 0;
        }
        else if (this.project.lifeSpanDays > 365) {
            this.project.lifeSpanDays = 365;
        }
    };
    return PetlProcessorComponent;
}(PetlBaseComponent));
export { PetlProcessorComponent };
